const LangMyRewards = {
  "myRewards._title": ["My Rewards", "QUÀ THƯỞNG CỦA TÔI"],
  "myRewards.header._validUntil": ["VALIDITY UNTIL", "NGÀY HẾT HẠN"],
  "myRewards.header._date": ["DATE", "NGÀY HẾT HẠN"],
  "myRewards.header._time": ["TIME", "THỜI GIAN"],
  "myRewards.header._rewards": ["REWARDS", "QUÀ THƯỞNG"],
  "myRewards.header._item": ["ITEM", "QUÀ THƯỞNG"],
  "myRewards.header._to": ["To", "Đến"],
  "myRewards.body._noAvailableRecord": [
    "YOU HAVE NOT MADE ANY REDEMPTIONS.",
    "BẠN KHÔNG CÓ QUÀ THƯỞNG."
  ],
  "myRewards.body._noAvailableClaim": [
    "You have no rewards to claim currently.",
    "BẠN KHÔNG CÓ QUÀ THƯỞNG ĐỂ NHẬN."
  ],
  "myRewards.body._noAvailableRedeem": [
    "You need more nuts to redeem rewards.",
    "BẠN KHÔNG THỂ NHẬN."
  ]
};

export default LangMyRewards;



// WEBPACK FOOTER //
// ./src/resources/modules/LangMyRewards.js